/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import "core-js";

import "regenerator-runtime/runtime";

require("../bootstrap");

import Vue from 'vue'

window.Vue = Vue

// import * as VueGoogleMaps from "vue2-google-maps";
import MapComponent from "./components/MapComponent.vue";

// Vue.use(VueGoogleMaps, {
//     load: {
//         key: "AIzaSyCloXMHnQI-oSWu4z9sv_WFCZK76sA7M7k",
//         libraries: ["places", "visualization"],
//         v: "3.39",
//         autobindAllEvents: true
//     }
// });

const app = new Vue({
    el: "#app",

    components: {
        MapComponent
    }
});

app.$mount("#app");

$(document).ready(function() {

    if (window.location.hash === "#register-account") {
        history.replaceState({}, document.title, ".");
        document.querySelector('section.register').scrollIntoView({ behavior: 'smooth' })
    }

    if (window.location.hash === "#contact") {
        $('#contact-form').addClass('open')
    }

    if (window.location.hash === "#guide") {
        history.replaceState({}, document.title, ".");
        document.querySelector('section.guide').scrollIntoView({ behavior: 'smooth' })
    }

    $(".scroll-to").click(function(e) {

        e.preventDefault();

        if (window.location.pathname === getPrefix() ) {
            document.querySelector('section.register').scrollIntoView({ behavior: 'smooth' })
        } else {
            window.location.replace(window.location.pathname + "#register-account");
        }
    });

    $(".order-product").click(function(e) {
        
        e.preventDefault();

        $('#type').attr('checked', $(this).data('value').length > 0)

        document.querySelector('#register').scrollIntoView({ behavior: 'smooth' })
    });

    $(".guide-toggle, #scroll-to-guide").click(function(e) {
        
        e.preventDefault();

        if (window.location.pathname === "/") {
            document.querySelector('section.guide').scrollIntoView({ behavior: 'smooth' })
        } else {
            window.location.replace("/#guide");
        }
    });

    $(".scroll-to-top").click(function(e) {
        e.preventDefault();
        document.querySelector('body').scrollIntoView({ behavior: 'smooth' })
    });

    $(".border").on("click", function(e) {
        $(".border").css("height", "48px");

        let radio = $(this).find(".form-check-input");

        if (radio.is(":checked")) {
            $(this).css("height", "auto");
        }
    });

    $("section.faq ul > li").on("click", function(e) {
        e.preventDefault();

        $("section.faq ul > li .answer").removeClass("open");

        const answer = $(this).find(".answer");

        if (answer.hasClass("open")) {
            answer.removeClass("open");
        } else {
            answer.addClass("open");
        }
    });

    $('#toggle-contact').on('click', function(e){
        e.preventDefault()
        $('#contact-form').toggleClass('open')
    })



    // video frontpage
    $('.show-video').on('click', function (e) {
        e.preventDefault();
        $('#video-demo').show()
        $('#video-demo .video-button').show()
    });

    $('#video-demo .video-button').on('click', function (e) {
        e.preventDefault();
        const video = $(this).siblings('video')[0]
        $(this).hide()

        if(!video.paused) {
            video.pause()
        } else {
            video.play()
        }

    });

    $('#video-demo .fas.fa-times').on('click', function (e) {
        e.preventDefault()
        const video = $(this).siblings('video')[0]
        video.currentTime = 0;
        video.pause()
        $('#video-demo').hide()
    });


    $('#video-demo .fas.fa-expand').on('click', function (e) {
        e.preventDefault()

        const video = $(this).siblings('video')[0]
        toggleFullScreen(video)

    });

    $('.language-toggle').on('click', function(e) {
        $(this).find('ul').toggleClass('open')
    })



    function getPrefix()
    {
        const languages = ['fr', 'de'];

        const path = window.location.pathname;

        let found = '/';
        
        for (let i = 0; i < languages.length; i++) {

            const lang = languages[i];

            if (path.includes(lang)) {

                const parts = path.split('/');

                if (parts[1] && lang === parts[1]) {

                    found = found + parts[1];

                    break;
                }
            }
        }
        
        return found;
    }

    function toggleFullScreen(vid) {
        if (vid.requestFullScreen) {
            vid.requestFullScreen();
        } else if (vid.webkitRequestFullScreen) {
            vid.webkitRequestFullScreen();
        } else if (vid.mozRequestFullScreen) {
            vid.mozRequestFullScreen();
        } else if (vid.msRequestFullscreen) {
            vid.msRequestFullscreen();
        } else if (vid.webkitEnterFullscreen) {
            vid.webkitEnterFullscreen(); //for iphone this code worked
        }
    }


});
